import { CanActivateFn, CanDeactivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RuntimeService } from '../../shared/services/runtime.service';
import { AuthService } from '../services/auth.service';

export const dataSyncGuard: CanActivateFn = () => {
  const runtime = inject(RuntimeService);
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!runtime.IsDesktopApplication) {
    return router.createUrlTree(['/login']);
  }

  // No valid session — this screen must never be reachable by typing the URL directly.
  if (!authService.isLoggedIn()) {
    if (!authService.hasLicence()) {
      return router.createUrlTree(['/verify-licence']);
    }
    return router.createUrlTree(['/login']);
  }

  return true;
};

// Full-page conflict resolution must not be abandoned by navigating away —
// Apply & Sync is the only path that clears showConflicts() and then routes.
export interface CanLeaveDataSync {
  canLeave(): boolean;
}

export const dataSyncCanDeactivateGuard: CanDeactivateFn<CanLeaveDataSync> = (
  component,
  _currentRoute,
  _currentState,
  nextState
) => {
  if (component.canLeave()) {
    return true;
  }

  // Session expiry / licence invalidation must still be able to leave this screen.
  const url = nextState.url.split('?')[0];
  return ['/login', '/verify-licence', '/authenticate'].some((path) => url.startsWith(path));
};
